import type { ReactNode } from "react";
import { List, Stack } from "@mui/material";
import { NavRow } from "../../../common/components/NavRow";
import { SectionHeader } from "../../../common/components/SectionHeader";

export interface MeDestination {
  label: string;
  to: string;
  icon: ReactNode;
  value?: ReactNode;
}

/** A titled group of navigation rows; `children` appends injected rows. */
export function MeDestinationList({
  title,
  items,
  children,
}: {
  title: string;
  items: readonly MeDestination[];
  children?: ReactNode;
}) {
  return (
    <Stack component="nav" aria-label={title} spacing={0.25}>
      <SectionHeader title={title} />
      <List disablePadding>
        {items.map((item) => (
          <NavRow key={item.to} {...item} />
        ))}
        {children}
      </List>
    </Stack>
  );
}
